module.exports = __webpack_public_path__ + "static/media/gitTogether-login.ceb1412a.png";